import React from 'react';
import { useTranslation } from 'react-i18next';

/** The "ÄTA #n" pill shared by the contract list and the document library. */
export function ContractVariationTag({ number }: { number: number | string | undefined }) {
  const { t } = useTranslation();
  return <span className="contract-list-variation-tag">{t('contracts.list.variationTag', { number })}</span>;
}
